"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const TextArea_1 = __importDefault(require("components/shared/TextArea"));
const shadowStyle = {
    boxShadow: '0px 1px 2px rgba(15, 23, 42, 0.06), 0px 1px 3px rgba(15, 23, 42, 0.1)'
};
const InsightTextArea = ({ id, textValue, handleOnChange, handleOnBlur, isViewGraph }) => {
    const wrapperInsightBoxCN = (0, classnames_template_literals_1.default)(`
    flex justify-center items-center 
    grow-0 flex-shrink-0 rounded-[4px] 
    border-[1px] border-solid border-n-300
    bg-n-300 w-[144px] text-center p-[16px]
    ${isViewGraph ? 'h-[209px]' : 'h-[144px]'}
  `);
    const ref = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(ref, () => handleOnBlur());
    const onKeyFunction = (e) => {
        if (e.key === 'Escape' || e.key === 'Enter')
            handleOnBlur();
    };
    return (react_1.default.createElement("div", { className: wrapperInsightBoxCN, style: shadowStyle, ref: ref },
        react_1.default.createElement(TextArea_1.default, { value: textValue, height: isViewGraph ? 177 : 112, onHandleChange: handleOnChange, onBlur: handleOnBlur, onKeyDown: onKeyFunction, textPlaceholder: "Add Insight", autoFocus: true })));
};
exports.default = InsightTextArea;
